import { combineReducers } from 'redux';
import modules from '../modules';

const reducersConfig = {};
for (const key in modules) {
  if (!modules.hasOwnProperty(key) || !modules[key].reducer) {
    continue;
  }
  reducersConfig[key] = modules[key].reducer;
}

const reducers = combineReducers(reducersConfig);
export default reducers;
